import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';

import { AuthService } from 'app/core/auth/auth.service';
import { PermissionActions } from '@core/permissions/permission.type';

export const PermissionModuleGuard: CanActivateFn | CanActivateChildFn = async (
    route
) => {
    const authService = inject(AuthService);
    const permissionAction = inject(PermissionActions);

    const user = await authService.checkAuthentication();
    const code: string = route.data?.code;

    permissionAction.setPermission(user);

    if (user) {
        if (
            user?.roles[0]?.code == 'subscriber' &&
            (code == 'users' || code == 'settings')
        )
            return false;

        return true;
    }

    return false;
};
